import { getUtcNow } from "../utils";
export async function softDelete(context) {
    const { service, method, params } = context;
    const { query = {} } = params;
    if (context.type !== 'before') {
        throw new Error(`The softDelete hook can only be used as a before hook!!!`);
    }
    const disableSoftDelete = query.$disableSoftDelete;
    delete query.$disableSoftDelete;
    if (disableSoftDelete === true) {
        return context;
    }
    context.params.query = Object.assign(query, { 'meta.deleted': null });
    if (method === 'remove') {
        if (context.id !== undefined) {
            const result = await service.patch(context.id, { meta: { deleted: getUtcNow() } }, params);
            context.result = result;
            context.event = null;
        }
    }
    return context;
}
//# sourceMappingURL=softDelete.js.map